import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from '@simple-contacts/react-router-async-routes';

export const getRedirectPath = () => {
  const profissional = JSON.parse(localStorage.getItem('profissional'));

  //console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaa', profissional);
  if (profissional) return '/admin/mapaLeito';
  localStorage.clear();
  return '/auth';
};

const isAuthenticated = (props, Component) => {
  const auth = JSON.parse(localStorage.getItem('profissional'));
  if (auth) return <Component {...props} />;
  return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />;
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      async
      {...rest}
      render={props => {
        return isAuthenticated(props, Component);
      }}
    />
  );
};
